export default __webpack_public_path__ + "static/media/chevron-down.964211ed.svg";